import { CUSTOM_EVENTS_METRICS } from 'modules/billing/constants';

export const CUSTOM_EVENTS_CARD_IDS = {
  cardId: 'custom-events-metrics',
};

export const CUSTOM_EVENTS_CARD_TEXT = {
  cardTitle: 'Custom events',
  projectBreakdownUrl: '/payments/info/dataUsage',
  totalCustomEventsDescription: 'Total number of custom events stored as of',
  totalCustomEventsHighWatermarkDescription: 'Highest number of custom events stored between',
  totalCustomEventsHighWatermarkName: 'High water mark',
  totalCustomEventsName: 'Total events stored',
};

export const CUSTOM_EVENTS_METRIC_NAMES = [
  CUSTOM_EVENTS_METRICS.totalCustomEventsHighWatermark,
  CUSTOM_EVENTS_METRICS.totalCustomEvents,
];
